/* eslint-disable */
/* @flow */

import React, { Component } from 'react'
import {
  Animated,
  Easing,
  Image,
  Text,
  View,
  PanResponder,
  Dimensions,
  ViewPropTypes,
} from 'react-native'
//import Shimmer from 'react-native-shimmer'

import { Images } from '../Themes'



import styles from './Styles/SlideButtonStyle'

const limitX = Dimensions.get('window').width / 2 - 40

class SlideButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pan: 0,
      animatedX: new Animated.Value(0),
      restartingX: false,
    };
  }

  componentDidMount() {
    this.panResponder = PanResponder.create({
      onMoveShouldSetResponderCapture: () => this.props.enabled,
      onMoveShouldSetPanResponderCapture: () => this.props.enabled,
      onPanResponderGrant: (e, gestureState) => {
        this.setState({ pan: 0 })
      },
      onPanResponderMove: (e, { dx }) => {
        dx < limitX && this.setState({ pan: dx })
      },
      onPanResponderRelease: (e, { dx }) => {
        this.onSliderReleased(dx)
      },
    })
  }

  onSliderReleased = (distanceX) => {
    if (distanceX < limitX) {
      this.restartAnimation()
    } else {
      this.onSlideTerminated()
    }
  }
  restartAnimation = () => {
    this.setState(
      {
        restartingX: true,
        animatedX: new Animated.Value(this.state.pan),
      },
      () => {
        Animated.timing(this.state.animatedX, {
          toValue: 0,
          duration: 500,
          easing: Easing.ease,
        }).start(() => this.setState({ restartingX: false }))
      }
    )
  }

  onSlideTerminated = () => {
    this.setState({ pan: this.state.pan })
    this.props.onSlide()
    setTimeout(this.restartAnimation, 500)
  }

  sliderTransform = () => {
    const { pan, animatedX } = this.state
    return this.state.restartingX
      ? { transform: [{ translateX: animatedX }] }
      : { transform: [{ translateX: pan }] }
  }
  render() {
    const { title, enabled, disabledText, style } = this.props

    const containerStyle = enabled
      ? styles.container
      : styles.containerDisabled
    return (
      <View style={[containerStyle, style]}>
        <Animated.View
          style={this.sliderTransform()}
          {...this.panResponder.panHandlers}>
          <View style={styles.containerSlider}>
            {enabled ? (
              <View style={styles.slider}>
                <Image source={Images.slideArrow} />
                <View animating={enabled}>
                  <Text style={styles.sliderText}>{title}</Text>
                </View>
              </View>
            ) : (
                <Text style={styles.sliderTextDisabled}>
                  {disabledText}
                </Text>
              )}
          </View>
        </Animated.View>
      </View>
    )
  }
}

export default SlideButton
